import { CallQueueState } from "../interfaces/queue"
import { Types } from "../types"
import { CallQueueActions } from "../types/Queues/actionsType"


const initialState: CallQueueState = {
    insertCallQueuePending: false,
    insertCallQueueSuccess: false,
    insertCallQueueError: '',
    queueInfo: {},
    success: false,
    errorMessage: '',


    getCallQueuePending: false,
    getCallQueueSuccess: false,
    getCallQueueError: '',
    queueList: [],

    uploadDefaultMusicPending: false,
    uploadDefaultMusicSuccess: false,
    uploadDefaultMusicError: '',
    uploadDefaultStatus: false,

    updateQueuePending: false,
    updateQueueSuccess: false,
    updateQueueError: '',
    successUpdate: false,
    messageUpdate: '',


    deleteQueuePending: false,
    deleteQueueSuccess: false,
    deleteQueueError: '',

    getActiveQueuePending: false,
    getActiveQueueSuccess: false,
    getActiveQueueError: '',
    successgetActiveQueue: false,
    messageGetActiveQueue: '',
    activeQueue: []


}


const queueReducer = (state = initialState, action: CallQueueActions) => {
    switch (action.type) {
        case Types.INSERT_CALL_QUEUE_REQUEST:
            return {
                ...state,
                insertCallQueuePending: true,
                insertCallQueueSuccess: false,
                insertCallQueueError: '',
                queueInfo: {},
                success: false,
                errorMessage: '',
            }

        case Types.INSERT_CALL_QUEUE_SUCCESS:
            return {
                ...state,
                insertCallQueuePending: false,
                insertCallQueueSuccess: true,
                insertCallQueueError: '',
                queueInfo: action.payload.params.callQueue,
                success: action.payload.params.success,
                errorMessage: action.payload.params.errorMessage,
            }

        case Types.INSERT_CALL_QUEUE_ERROR:
            return {
                ...state,
                insertCallQueuePending: false,
                insertCallQueueSuccess: false,
                insertCallQueueError: action.payload,
                queueInfo: {},
                success: false,
                errorMessage: '',
            }
        //Get*********************************************************************************************************** */
        case Types.GET_QUEUE_REQUEST:
            return {
                ...state,
                getCallQueuePending: true,
                getCallQueueSuccess: false,
                getCallQueueError: '',
                queueList: []
            }

        case Types.GET_QUEUE_SUCCESS:
            return {
                ...state,
                getCallQueuePending: false,
                getCallQueueSuccess: true,
                getCallQueueError: '',

                queueList: action.payload.params
            }

        case Types.GET_QUEUE_ERROR:
            return {
                ...state,
                getCallQueuePending: false,
                getCallQueueSuccess: false,
                getCallQueueError: action.payload,
                queueList: []
            }

        //Upload Default Music****************************************************************************************************************** */
        case Types.UPLOAD_DEFAULT_MUSIC_REQUEST:
            return {
                ...state,
                uploadDefaultMusicPending: true,
                uploadDefaultMusicSuccess: false,
                uploadDefaultMusicError: '',
                uploadDefaultStatus: false
            }
        case Types.UPLOAD_DEFAULT_MUSIC_SUCCESS:
            return {
                ...state,
                uploadDefaultMusicPending: false,
                uploadDefaultMusicSuccess: true,
                uploadDefaultMusicError: '',
                uploadDefaultStatus: action.payload.params
            }
        case Types.UPLOAD_DEFAULT_MUSIC_ERROR:
            return {
                ...state,
                uploadDefaultMusicPending: false,
                uploadDefaultMusicSuccess: false,
                uploadDefaultMusicError: action.payload,
                uploadDefaultStatus: false
            }
        //UPdate queue********************************************************************************************************************    
        case Types.UPDATE_QUEUE_REQUEST:
            return {
                ...state,
                updateQueuePending: true,
                updateQueueSuccess: false,
                updateQueueError: '',
            }

        case Types.UPDATE_QUEUE_SUCCESS:

            return {
                ...state,
                updateQueuePending: false,
                updateQueueSuccess: true,
                updateQueueError: '',
                successUpdate: action.payload.params.success,
                messageUpdate: action.payload.params.errorMessage
            }

        case Types.UPDATE_QUEUE_ERROR:
            return {
                ...state,
                updateQueuePending: false,
                updateQueueSuccess: false,
                updateQueueError: action.payload,

            }
        //Delete****************************************************************** */
        case Types.DELETE_QUEUE_REQUEST:
            return {
                ...state,
                deleteQueuePending: true,
                deleteQueueSuccess: false,
                deleteQueueError: ''
            }

        case Types.DELETE_QUEUE_SUCCESS:
            return {
                ...state,
                deleteQueuePending: false,
                deleteQueueSuccess: true,
                deleteQueueError: ''
            }

        case Types.DELETE_QUEUE_ERROR:
            return {
                ...state,
                deleteQueuePending: false,
                deleteQueueSuccess: false,
                deleteQueueError: action.payload,

            }


        //GetActiveQueue*******************************************************************************
        case Types.GET_ACTIVE_QUEUE_REQUEST:
            return {
                ...state,
                getActiveQueuePending: true,
                getActiveQueueSuccess: false,
                getActiveQueueError: '',
                successgetActiveQueue: false,
                messageGetActiveQueue: '',
            }

        case Types.GET_ACTIVE_QUEUE_SUCCESS:
            return {
                ...state,
                getActiveQueuePending: false,
                getActiveQueueSuccess: true,
                getActiveQueueError: '',
                successgetActiveQueue: action.payload.params.success,
                messageGetActiveQueue: action.payload.params.errorMessage,
                activeQueue: action.payload.params.callQueueActiveCall
            }

        case Types.GET_ACTIVE_QUEUE_ERROR:
            return {
                ...state,
                getActiveQueuePending: false,
                getActiveQueueSuccess: false,
                getActiveQueueError: action.payload,
                successgetActiveQueue: false,
                messageGetActiveQueue: '',

            }



        //**************************************************** */
        case Types.RESET_INSERT_QUEUE:
            return {
                ...state,
                insertCallQueuePending: false,
                insertCallQueueSuccess: false,
                insertCallQueueError: '',
                success: false,
                queueInfo: {},

            }
        case Types.RESET_UPDATE_QUEUE:
            return {
                ...state,
                updateQueuePending: false,
                updateQueueSuccess: false,
                updateQueueError: '',
                successUpdate: false,
                messageUpdate: '',

            }

        case Types.RESET_ACTIVE_QUEUE:
            return {
                ...state,
                getActiveQueuePending: false,
                getActiveQueueSuccess: false,
                getActiveQueueError: '',
                successgetActiveQueue: false,
                messageGetActiveQueue: '',
            }
        case Types.RESET_DELETE_QUEUE:
            return {
                ...state,
                deleteQueuePending: false,
                deleteQueueSuccess: false,
                deleteQueueError: '',
            }


        default:
            return {
                ...state
            }
    }
}

export default queueReducer